<template>
  <ECharts :autoresize="true" :options="options"></ECharts>
</template>

<script>
import ECharts from 'vue-echarts/components/ECharts.vue';
import 'echarts/lib/chart/pie';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
// import 'echarts/lib/component/dataset';
import 'echarts/lib/component/legend';

export default {
  components: {
    ECharts,
  },
  data() {
    return {
      options: {},
    };
  },
  props: {
    hdata: {
      type: Object || Array,
      default: () => ({}),
    },
    title: {
      type: String,
      default: '',
    },
  },
  watch: {
    hdata() {
      if (this.hdata) {
        this.getInit();
      }
    },
  },
  created() {
    this.getInit();
  },
  methods: {
    // 获取X轴Y轴的数据
    getInit() {
      let data = [];
      if (this.hdata) {
        data = [
          { name: '在线', value: this.hdata.On ? this.hdata.On : 0 },
          { name: '离线', value: this.hdata.Off ? this.hdata.Off : 0 },
        ];
      }
      let a = 0;
      for (let i = 0; i < data.length; i++) {
        a += data[i].value;
      }
      // 增加下半空白
      data.push({ value: a, name: '', itemStyle: { normal: { color: 'rgba(0,0,0,0)' } } });
      const opt = {
        title: {
          text: this.title,
          x: 'center',
          top: 15,
          textStyle: {
            fontWeight: 'normal',
            fontSize: 16,
          },
          subtext: [
            `{value|${a}}`,
            '{name|总点位数}',
          ].join('\n'),
          subtextStyle: {
            verticalAlign: 'middle',
            rich: {
              value: {
                color: '#13B991',
                fontSize: 20,
                fontWeight: 'bold',
                lineHeight: 20,
              },
              name: {
                color: '#909399',
                lineHeight: 20,
              },
            },
          },
          itemGap: 100,
        },
        legend: {
          orient: 'vertical',
          y: 'center',
          x: 'right',
          data: [
            // name和下面的series中data的name对应显示。后面加textStyle可设置图例后面文字的颜色
            { name: '在线', textStyle: { color: '#B3BDC6' } },
            { name: '离线', textStyle: { color: '#B3BDC6' } },
          ],
          /* 图例旁边显示数据 */
          formatter(name) {
            let legendIndex = 0;
            const labels = [
              { name: '在线', textStyle: { color: '#B3BDC6' } },
              { name: '离线', textStyle: { color: '#B3BDC6' } },
            ];
            labels.forEach((value, i) => {
              if (value.name === name) {
                legendIndex = i;
              }
            });
            return `${name}: ${data[legendIndex].value}`;
          },
        },
        tooltip: {
          trigger: 'item',
          formatter(param) {
            let str = '<style>td{padding:5px;}</style><table>';
            let c = 0;
            if (a) {
              c = (param.value / a) * 100;
              c = c.toFixed(1);
            }
            str = `${param.data.name}: ${str + c}%`;
            return str;
          },
        },
        textStyle: {
          color: 'white',
        },
        series: [
          {
            type: 'pie',
            startAngle: 180,
            radius: ['60%', '70%'],
            center: ['50%', '65%'],
            data,
            label: { show: false },
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
        color: ['#17BC9A', '#EBF5F7'],
      };
      this.options = opt;
    },
  },
};
</script>

<style scoped>
.echarts {
  width: 100%;
  height: 100%;
}
</style>
